import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

/** รองรับทั้งรูปทรง response แบบ Strapi v4 (data.attributes) และ v5 (flat) */
function picUrl(pic) {
  return pic?.data?.attributes?.url || pic?.data?.url || pic?.url || "";
}

/** แถวข้อมูลแบบเว็บ sfa: ไอคอนเล็กสีเทาอยู่หน้าข้อความ */
function InfoRow({ icon, children }) {
  return (
    <div className="flex items-start gap-[10px] text-meta text-darkGray text-left">
      <FontAwesomeIcon
        icon={icon}
        className="w-[16px] shrink-0 mt-[0.35em] text-[16px] text-lightGray2"
      />
      <span className="min-w-0 break-words line-clamp-2">{children}</span>
    </div>
  );
}

export default function StaffCard(props) {
  const url = picUrl(props.data.profile_pic);
  const role =
    props.lang === "en"
      ? props.data.role_EN || props.data.role_TH
      : props.data.role_TH || props.data.role_EN;

  return (
    <div className="w-full h-full rounded-[12px] border-[1px] border-lightGray2 bg-white flex flex-col">
      {/* กรอบรูปสัดส่วน 3:4 ยึดขอบบนไว้ — รูปที่สูงกว่ากรอบจะโดนตัดแค่ด้านล่าง หัวไม่ขาด */}
      <div className="w-full aspect-[3/4] bg-lightGray rounded-t-[12px] overflow-hidden">
        {url && (
          <img
            className="w-full h-full object-cover object-top"
            src={`${process.env.REACT_APP_API_URL}${url}`}
            alt={props.data.name_TH || props.data.name_EN || ""}
          />
        )}
      </div>
      <div className="p-[16px]">
        {/* โชว์ชื่อเฉพาะภาษาของหน้านั้น ถ้าภาษานั้นไม่มีค่อยใช้อีกภาษาแทน */}
        <p className="text-lead font-bold text-slateGray text-left">
          {props.lang === "en"
            ? props.data.name_EN || props.data.name_TH
            : props.data.name_TH || props.data.name_EN}
        </p>

        <div className="mt-[10px] pt-[10px] border-t-[1px] border-lightGray flex flex-col gap-[4px]">
          {role && <InfoRow icon={faBriefcase}>{role}</InfoRow>}
          {props.is_staff && props.data.email && (
            <InfoRow icon={faEnvelope}>
              <a href={`mailto:${props.data.email}`} className="hover:text-brand">
                {props.data.email}
              </a>
            </InfoRow>
          )}
          {props.is_staff && props.data.contact && (
            <InfoRow icon={faPhone}>
              <a
                href={`tel:${String(props.data.contact).replace(/[^\d+]/g, "")}`}
                className="hover:text-brand"
              >
                {props.data.contact}
              </a>
            </InfoRow>
          )}
        </div>
      </div>
    </div>
  );
}
